import { staffMemberViewConfiguration } from './staffMemberViewConfiguration';
import { type PortalUser, type ViewConfiguration } from './types';

export function getViewConfiguration(portalUser: PortalUser): ViewConfiguration | undefined {
  if (portalUser.permissions.includes('FlipdishStaff')) {
    return undefined;
  }

  // AuthZ / Zeus may supply the string 'StaffMember'; the Zeus client enum does not
  // yet include that member, so compare against the literal role name.
  if (portalUser.role === 'StaffMember') {
    return staffMemberViewConfiguration;
  }

  return undefined;
}
